export default __webpack_public_path__ + "b34683183eb03af2457008eddf0ae761.png";